import { Color, ColorInput } from '../../../../../../types';

export const mapColorToColorInput = (colors: Color[]): ColorInput[] => [
	...colors.map((color) => ({
		label: color.name,
		value: color.id.toString(),
		color: color.primaryRgbHighlightCode,
		priceDescription: color.price ? `€ ${color.price} per maand` : 'Geen extra kosten',
	})),
];
